module.exports = __webpack_public_path__ + "static/banner-logo-dc99b2719b34150102bfafb407cd5e11.png";